<p-toolbar class="cc-side-bar" [ngClass]="sidebarToggled?'max-size':'min-size'">
  <div class="cc-side-bar-top">
    <span [class]="'bar-button button-resize-toggle'" (click)="toggleFilterBarSize()">
      <i [class]="'bar-button-ico fas fa-bars'"></i>
    </span>
    <span *ngFor="let menuItem of menuItemsTop">
      <span *ngIf="menuItem.visible"
            [class]="'bar-button'
            +('/'+menuItem.id===router.url?' bar-button-active':'')
            +(menuItem.styleClass?' '+menuItem.styleClass:'')"
            [pTooltip]="menuItem.label|translate"
            (click)="menuItem.command()">
        <i [class]="'bar-button-ico '+ menuItem.icon"></i>
        <div class="bar-button-text">{{ menuItem.label|translate | translate }}</div>
      </span>
    </span>
    <ng-content select="[top]"></ng-content>
  </div>
  <div class="cc-side-bar-bottom">
    <span *ngFor="let menuItem of menuItemsBottom">
      <span *ngIf="menuItem.visible"
            [id]="menuItem.id"
            [class]="'bar-button'+(menuItem.path===router.url?' bar-button-active':'')"
            [pTooltip]="menuItem.label|translate"
            (click)="menuItem.items?sideMenu.toggle($event):menuItem.command()">
        <i [class]="'bar-button-ico '+ menuItem.icon"></i>
        <div class="bar-button-text">{{ menuItem.label|translate | translate }}</div>
      </span>
      <p-menu #sideMenu [popup]="true"
              [id]="menuItem.id" [model]="menuItem.items" [appendTo]="'body'"></p-menu>
    </span>
    <ng-content select="[bottom]"></ng-content>
  </div>
</p-toolbar>

<span
  [ngClass]="'side-bar-body side-bar-'+(sidebarToggled?'max':'min')+'-size' + (transitionActive?' transition-active':'')">
    <ng-content select="[body]"></ng-content>
</span>
